<template>
  <div id="tags-view-container" class="tags-view-container" v-if="visitedViews.length>0">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ tag.title }}
        <span
          v-if="!tag.meta.affix"
          class="el-icon-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li
        v-if="!(selectedTag.meta&&selectedTag.meta.affix)"
        @click="closeSelectedTag(selectedTag)"
      >关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
    import ScrollPane from "./ScrollPane";
    import path from "path";

    export default {
        components: { ScrollPane },
        data() {
            return {
                visible: false,
                top: 0,
                left: 0,
                selectedTag: {},
                affixTags: []
            };
        },
        computed: {
            visitedViews() {
                let visitedViews = this.$store.state.tagsView.visitedViews;
                // console.log(visitedViews)
                return visitedViews;
            }
        },
        watch: {
            $route() {
                this.addTags();
                this.moveToCurrentTag();
            },
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu)
                } else {
                    document.body.removeEventListener('click', this.closeMenu)
                }
            }
        },
        mounted() {
            this.addTags();
        },
        methods: {
            isActive(route) {
                return route.path === this.$route.path;
            },
            filterAffixTags(routes, basePath = "/") {
                let tags = [];
                routes.forEach(route => {
                    if (route.meta && route.meta.affix) {
                        const tagPath = path.resolve(basePath, route.path);
                        tags.push({
                            fullPath: tagPath,
                            path: tagPath,
                            name: route.name,
                            meta: { ...route.meta }
                        });
                    }
                    if (route.children) {
                        const tempTags = this.filterAffixTags(route.children, route.path);
                        if (tempTags.length >= 1) {
                            tags = [...tags, ...tempTags];
                        }
                    }
                });
                return tags;
            },
            initTags() {
                const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
                for (const tag of affixTags) {
                    // Must have tag name
                    if (tag.name) {
                        this.$store.dispatch("tagsView/addVisitedView", tag);
                    }
                }
            },
            addTags() {
                const { name } = this.$route;
                if(name=="empty"){
                    return false;
                }

                if (name) {
                    this.$store.dispatch("tagsView/addView", this.$route);
                }
                return false;
            },
            moveToCurrentTag() {
                const tags = this.$refs.tag;
                this.$nextTick(() => {
                    for (const tag of tags) {
                        if (tag.to.path === this.$route.path) {
                            this.$refs.scrollPane.moveToTarget(tag);
                            // when query is different then update
                            if (tag.to.fullPath !== this.$route.fullPath) {
                                this.$store.dispatch("tagsView/updateVisitedView", this.$route);
                            }
                            break;
                        }
                    }
                });
            },
            refreshSelectedTag(view) {
                this.$store.dispatch("tagsView/delCachedView", view).then(() => {
                    const { fullPath } = view;
                    this.$nextTick(() => {
                        this.$router.replace({
                            path: "/redirect" + fullPath
                        });
                    });
                });
            },
            closeSelectedTag(view) {
                this.$store
                    .dispatch("tagsView/delView", view)
                    .then(({ visitedViews }) => {
                        if (this.isActive(view)) {
                            this.toLastView(visitedViews, view);
                        }
                    });
            },
            closeOthersTags() {
                this.$router.push(this.selectedTag);
                this.$store
                    .dispatch("tagsView/delOthersViews", this.selectedTag)
                    .then(() => {
                        this.moveToCurrentTag();
                    });
            },
            closeAllTags(view) {
                this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
                    if (this.affixTags.some(tag => tag.path === view.path)) {
                        return;
                    }
                    this.toLastView(visitedViews, view);
                });
            },
            toLastView(visitedViews, view) {

                const latestView = visitedViews.slice(-1)[0];
                // console.log(latestView)
                if (latestView) {
                    if (latestView.path == "/index" || latestView.path == "/index/") {
                        this.$router.push({ path: "/index" });
                    } else {
                        this.$router.push(latestView);
                    }
                } else {
                    this.$router.push("/empty");
                    // // now the default is to redirect to the home page if there is no tags-view,
                    // // you can adjust it according to your needs.
                    // if (view.name === "Dashboard") {
                    //   // to reload home page
                    //   this.$router.replace({ path: "/redirect" + view.fullPath });
                    // } else {
                    //   this.$router.push("/");
                    // }
                }
            },
            openMenu(tag, e) {
                // debugger
                const menuMinWidth = 105;
                const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
                const offsetWidth = this.$el.offsetWidth; // container width
                const maxLeft = offsetWidth - menuMinWidth; // left boundary
                const left = e.clientX - offsetLeft + 15; // 15: margin right
                // console.log(offsetLeft,e.clientX,this.$el.offsetWidth)
                if (left > maxLeft) {
                    this.left = maxLeft;
                } else {
                    this.left = left;
                }
                this.left=e.clientX+20;
                this.top = e.clientY;
                this.visible = true;
                this.selectedTag = tag;
            },
            closeMenu() {
                this.visible = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
  .tags-view-container {
    height: 34px;
    width: calc(100vw - 264px);
    [data-theme="theme1"] & {
      background:rgba(0,24,44,1);
      box-shadow:0px 6px 20px rgba(0,237,231,0.5);
    }
    [data-theme*="theme2"] & {
      background:#fff;
      box-shadow: 0 1px 7px rgba(3,186,255,.2);

    }

    // background: #fff;
    margin-left: 10px;
    margin-bottom: 5px;
    margin-top: 15px;
    // border-bottom: 1px solid #d8dce5;
    // box-shadow:rgba(3, 186, 255, 0.2) 0px 1px 7px ;
    // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        // border: 1px solid #d8dce5;

        [data-theme="theme1"] & {
          border-bottom: 5px solid #00182C;
          color: #B9B9B9;
          background: rgba(0,24,44,1);
        }
        [data-theme*="theme2"] & {
          border-bottom: 5px solid #fff;
          color: #495060;
          background: #fff;
        }
        padding: 0 8px;
        font-size: 12px;
        margin-left: 5px;
        margin-top: 4px;
        &:first-of-type {
          margin-left: 15px;
        }
        &:last-of-type {
          margin-right: 15px;
        }

        [data-theme="theme1"] & {
          &.active {
            color: #00E7E1;
            border-color: #00E9E2;
            &::before {
              content: "";
              background: #00E7E1;
              display: inline-block;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              position: relative;
              margin-right: 2px;
            }
          }
        }
        [data-theme*="theme2"] & {
          &.active {
            color: #0060aa;
            border-color: #0060aa;
            &::before {
              content: "";
              background: #0060aa;
              display: inline-block;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              position: relative;
              margin-right: 2px;
            }
          }
        }

      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 3000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>

<style lang="scss">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;
        &:before {
          transform: scale(0.6);
          display: inline-block;
          vertical-align: -3px;
        }
        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TagsView/index.vue